import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  /**
   * Add auth header including
   *
   * @param req
   * @param next
   * @returns
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Sending an invalid header to this endpoint that doesn't require one causes 500 errors.
    if (!req.url.endsWith('accessCodeCheck')) {
      const authHeader = this.authService.getAuthorizationHeader();
      // Clone the request to add the new header.
      const authReq = req.clone({headers: req.headers.set('Authorization', authHeader ? 'Bearer ' + authHeader : '')});
      /// / Pass on the cloned request instead of the original request.
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
